import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles((theme) => ({
  titleCell: {
    width: "100%",
    margin: 4,
    alignItems: "center",
  },
  cell: {
    margin: 4,
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
  },
  headerCell: {
    fontSize: 14,
    fontWeight: 600,
  },
  valueCell: {
    minWidth: 124,
    width: 124,
  },
  colorCell: {
    minWidth: 48,
    width: 48,
  },
  sticky: {
    position: "sticky",
    bottom: -24,
    backgroundColor: theme.props.backgroundSecondary,
    paddingBottom: 8,
  },
  noRemoval: {
    minWidth: 48,
    width: 48,
  },
}));

export default useStyle;